(() => {
  const cleanCertificationSymbols = (scope = document) => {
    const page = scope.querySelector?.('.ice-page--certificaciones');
    if (!page || page.dataset.iceEditorialIcons === 'ready') return;

    page.querySelectorAll('.cert-card h3, .cert-layer h4').forEach((heading) => {
      heading.textContent = heading.textContent.replace(/^[\s🔥✅🛡️🧵]+/u, '').trim();
    });

    page.querySelectorAll('.cert-layer').forEach((layer) => {
      Array.from(layer.childNodes).forEach((node) => {
        const value = node.textContent?.replace(/[\s\uFE0F]/gu, '') ?? '';
        if (/^(🔥|🛡|🧵)$/u.test(value)) {
          node.remove();
        }
      });
    });

    page.querySelectorAll('.cert-section h2').forEach((heading, index) => {
      if (index > 0) heading.classList.add('cert-heading--secondary');
    });

    page.dataset.iceEditorialIcons = 'ready';
  };

  const normalizeAboutPage = (scope = document) => {
    const page = scope.querySelector?.('.ice-page--sobre-ice-bag');
    if (!page || page.dataset.iceAboutTypography === 'ready') return;

    page.querySelectorAll('.section-header h1, .prose h1, .prose h2, .prose h3, .prose h4').forEach((heading) => {
      heading.style.removeProperty('font-size');
      heading.classList.add('ice-about-heading');
    });

    page.querySelectorAll('.prose li').forEach((item) => {
      item.style.removeProperty('margin-left');
      item.style.removeProperty('padding-left');
      item.style.removeProperty('text-indent');
    });

    page.dataset.iceAboutTypography = 'ready';
  };

  const initialize = (scope = document) => {
    cleanCertificationSymbols(scope);
    normalizeAboutPage(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
